module.exports = __webpack_public_path__ + "static/logo-wired-9d0dd820fd623f882d2d89ef35910b70.png";